<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <v-data-table
      :headers="headers"
      :items="aggregators"
      item-key="nmid"
      :options.sync="options"
      :server-items-length="totalAggregators"
      :loading="loading"
      loading-text="Loading... Please wait"
      :item-class="rowClass"
      class="d-print-table"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 25, 50],
        // showFirstLastPage: true,
      }"
      sort-by="name"
      fixed-header
      :style="{ padding: '10px', height: '70vh' }"
    >
      <template v-slot:[`body.prepend`]>
        <tr>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.source_onboarding"
              :items="sourceOnboardingList"
              label="Source Onboarding"
              item-text="text"
              item-value="value"
              @change="getData"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.name"
              type="text"
              label="Nama Aggregator"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.address"
              type="text"
              label="Alamat Lengkap"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-menu
              ref="dateMenu"
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFormatted"
                  label="Tanggal Active"
                  v-bind="attrs"
                  @blur="search.active_date = parseDate(dateFormatted)"
                  v-on="on"
                  hide-details="true"
                  dense
                />
              </template>
              <v-date-picker
                v-model="search.active_date"
                no-title
                scrollable
                @input="dateMenu = false"
              >
                <v-spacer />
                <v-btn text color="primary" @click="dateMenu = false">
                  Cancel
                </v-btn>
              </v-date-picker>
            </v-menu>
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-menu
              ref="dateMenuInactive"
              v-model="dateMenuInactive"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFormattedInactive"
                  label="Tanggal Inactive"
                  v-bind="attrs"
                  @blur="
                    search.inactive_date = parseDate(dateFormattedInactive)
                  "
                  v-on="on"
                  hide-details="true"
                  dense
                />
              </template>
              <v-date-picker
                v-model="search.inactive_date"
                no-title
                @input="dateMenuInactive = false"
                scrollable
              >
                <v-spacer />
                <v-btn text color="primary" @click="dateMenuInactive = false">
                  Cancel
                </v-btn>
              </v-date-picker>
            </v-menu>
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.status"
              :items="listAccountStatus"
              label="Status"
              item-text="text"
              item-value="value"
              @change="getData"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
        </tr>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-spacer />
          <template>
            <v-btn
              color="primary"
              dark
              :style="{ 'margin-right': '10px' }"
              class="mb-2"
              @click="registerAggregator"
            >
              New Aggregator
            </v-btn>
            <v-btn
              color="warning"
              class="mb-2"
              @click="getData"
              :loading="loading"
              :disabled="loading"
              ><v-icon>mdi-restart</v-icon
              ><template v-slot:loader>
                <span class="custom-loader">
                  <v-icon light>mdi-cached</v-icon>
                </span>
              </template>
            </v-btn>
          </template>
          <v-menu
            offset-y
            rounded="lg"
            transition="slide-y-transition"
            bottom
            left
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="warning"
                class="mb-2"
                icon
                dark
                v-bind="attrs"
                v-on="on"
              >
                <v-icon light size="20">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item link @click="exportItem()">
                <v-list-item-icon>
                  <v-icon>mdi-file-excel</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Export to excel</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="viewItem(item)"> mdi-eye </v-icon>
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" style="text-align: center">
          {{ item.active_date }}
        </td>
      </template>
      <template v-slot:item="{ item, index }">
        <tr
          :key="index"
          :style="{ cursor: 'pointer', backgroundColor: index % 2 === 0 ? '#EEEEEE' : '#FFF', }"
          :class="selectedRow === index ? 'indigo lighten-4' : ''"
          @click="selectRow(index)"
        >
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ (options.page - 1) * options.itemsPerPage + index + 1 }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.source_onboarding_name }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.name }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.address }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.mobile_phone }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.active_date }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.inactive_date }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.status }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            <v-menu
              offset-y
              rounded="lg"
              transition="slide-y-transition"
              bottom
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="warning"
                  class="mb-2"
                  icon
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon light size="20">mdi-dots-horizontal</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item link :to="`/inputer/aggregator/view/${item.id}`">
                  <v-list-item-icon>
                    <v-icon>mdi-eye</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>View Detail</v-list-item-title>
                </v-list-item>
                <v-list-item
                  link
                  @click="editItem(item)"
                  :disabled="item.status.toLowerCase() == 'closed'"
                >
                  <v-list-item-icon>
                    <v-icon :disabled="item.status.toLowerCase() == 'closed'"
                      >mdi-pencil</v-icon
                    >
                  </v-list-item-icon>
                  <v-list-item-title>Edit Aggregator</v-list-item-title>
                </v-list-item>
                <v-list-item link @click="viewListSubMerchant(item)">
                  <v-list-item-icon>
                    <v-icon>mdi-format-list-bulleted</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>View List Sub Merchant</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="clearSearch"> Reset </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import {
  dataListMerchantCriteria,
  dataListAccountStatus,
  dataQrType,
  dataSourceOnboardingList,
} from '../../../store/params';
import { date } from '../../../lib/helpers';

export default {
  data: () => ({
    show: false,
    view: false,
    limit: '5',
    page: '1',
    options: {},
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: 'No',
        align: 'start',
        value: 'id',
        width: '10',
        sortable: false,
      },
      {
        text: 'Source Onboarding',
        value: 'source_onboarding',
        width: '200',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Nama Aggregator',
        value: 'name',
        width: '200',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Alamat Lengkap',
        value: 'address',
        width: '250',
        align: 'start',
        sortable: false,
      },
      {
        text: 'No. Handphone',
        value: 'mobile_phone',
        width: '150',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Tanggal Active',
        value: 'active_date',
        width: '150',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Tanggal Inactive',
        value: 'inactive_date',
        width: '200',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Status',
        value: 'status',
        width: '150',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Action',
        value: 'actions',
        width: '100',
        sortable: false,
      },
    ],
    editedIndex: -1,
    search: {
      source_onboarding: '',
      name: '',
      inactive_date: null,
      mobile_phone: '',
      address: '',
      status: '',
      active_date: null,
    },
    selectedRow: '',
    listAggregatorCriteria: dataListMerchantCriteria,
    listAccountStatus: dataListAccountStatus,
    listQrType: dataQrType,
    dateFormatted: '',
    dateMenu: false,
    dateFormattedInactive: '',
    dateMenuInactive: false,
    sourceOnboardingList: dataSourceOnboardingList,
  }),

  computed: {
    flashErrorMessage() {
      return this.$store.state.inputer.aggregator.flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.inputer.aggregator.flashError;
      },
      set() {
        this.$store.commit('inputer/aggregator/setFlashErrorMessage', '');
      },
    },

    errorValidation() {
      return this.$store.state.inputer.aggregator.errors;
    },
    loading() {
      return this.$store.state.inputer.aggregator.loading;
    },
    aggregators() {
      return this.$store.state.inputer.aggregator.allAggregators;
    },
    totalAggregators() {
      return this.$store.state.inputer.aggregator.totalAggregators;
    },
    totalPage() {
      return this.$store.state.inputer.aggregator.totalPage;
    },
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    'search.active_date': {
      handler() {
        this.dateFormatted = this.formatDate(this.search.active_date);
        this.getData();
      },
    },

    'search.inactive_date': {
      handler() {
        this.dateFormattedInactive = this.formatDate(this.search.inactive_date);
        this.getData();
      },
    },

    show() {
      if (!this.show) {
        this.clearSearch();
      }
    },
  },

  methods: {
    selectRow(index) {
      if (this.selectedRow != index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.source_onboarding = '';
      this.search.name = '';
      this.search.mobile_phone = '';
      this.search.address = '';
      this.search.status = '';
      this.search.active_date = null;
      this.search.inactive_date = null;
      this.$nextTick(() => {
        this.getData();
      });
    },

    getData() {
      this.$store.commit('inputer/aggregator/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('inputer/aggregator/fetchAggregators', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage == 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },

    viewItem(item) {
      this.$router.push({ path: `/inputer/aggregator/view/${item.id}` });
    },

    editItem(item) {
      this.$router.push({ path: `/inputer/aggregator/update/${item.id}` });
    },

    viewListSubMerchant(item) {
      this.$router.push({
        path: `/inputer/aggregator/${item.id}/sub-merchant`,
      });
    },

    closeFlash() {
      this.$store.commit('inputer/aggregator/setFlashErrorMessage', '');
    },

    registerAggregator() {
      this.$router.push({ path: '/inputer/aggregator/register' });
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    exportItem() {
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store.dispatch('inputer/aggregator/exportList', {
        date,
        page,
        itemsPerPage,
        sortBy,
        sortDesc,
        search: this.search,
        view: 'aggregator',
        IDAggregator: '',
        IDMerchant: '',
      });
    },
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
@media only screen and (min-width: 600px) {
  .fixed-row {
    position: -webkit-sticky;
    position: sticky;
    top: 48px;
    z-index: 1;
    background-color: white;
  }
}
</style>
